var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"deleteButton",attrs:{"icon":"","aria-label":_vm.ariaLabel}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }